export default {
  computed: {
    isOnboarding() {
      return this.$storage.onboarding;
    },
    isLightMenu() {
      return this.$route.meta.onboardingStep && this.$storage.onboarding;
    },
  },
};
